import { styled } from '@mui/material/styles';
import { SIDEBAR_CLOSED_WIDTH } from 'theme';

const PREFIX = 'SelectionSummaryBar';

export const classes = {
  root: `${PREFIX}-root`,
  item: `${PREFIX}-item`,
  label: `${PREFIX}-label`,
  value: `${PREFIX}-value`,
  divider: `${PREFIX}-divider`,
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    fontFamily: 'Roboto Condensed, Roboto, sans-serif',
    fontSize: '0.8125rem',
    lineHeight: 1,
    height: theme.spacing(4),
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    padding: `0 ${theme.spacing(1.5)}`,
    marginTop: theme.spacing(4.5),
    float: 'left',
    marginLeft: '0.75rem',
    zIndex: 1,

    '.MuiDrawer-root &': {
      position: 'fixed',
      bottom: theme.spacing(1),
      left: SIDEBAR_CLOSED_WIDTH + parseInt(theme.spacing(1), 10),
      float: 'none',
      marginTop: 0,
      marginLeft: 0,
      boxShadow: theme.shadows[4],
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.grey[300]}`,
      zIndex: theme.zIndex.drawer + 1,
    },
  },

  [`& .${classes.item}`]: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },

  [`& .${classes.label}`]: {
    fontWeight: 600,
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.025em',
  },

  [`& .${classes.value}`]: {
    fontWeight: 500,
    color: theme.palette.text.primary,
  },

  [`& .${classes.divider}`]: {
    color: theme.palette.grey[300],
    userSelect: 'none',
  },
}));
